import React, { useState } from 'react';
import { useProjectStore } from '../../hooks/useProjectStore';
import { ECO_PARAMS, useActiveDesign, computeCost, ETH, ecoInputStyle } from './ecoShared';

// /economics/cost — 成本构成
const BAR_COLOR = ['#2874A6', '#C2533A', '#1E8449', '#6A4C93', '#D4770C', '#8598AD'];

export default function EcoCostPage() {
  const { currentProject } = useProjectStore();
  const { fluid, prop, name, loading } = useActiveDesign(currentProject?.id);
  const [, force] = useState(0);
  const p = ECO_PARAMS;
  const set = (k: keyof typeof p, v: number) => { (p[k] as number) = v; force((x) => x + 1); };

  const { items, total } = computeCost(p, fluid, prop);
  const maxVal = Math.max(...items.map((i) => i.val), 1);

  if (!currentProject) return <div style={{ padding: 40, color: ETH.textSec }}>请先选择项目</div>;

  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', background: ETH.bg, fontFamily: 'inherit' }}>
      <div style={{ padding: '8px 20px', borderBottom: `1px solid ${ETH.headerBorder}`, display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
        <h2 style={{ fontSize: 15, fontWeight: 700, color: ETH.text, margin: 0 }}>成本构成</h2>
        <span style={{ fontSize: 12, color: ETH.textMuted }}>
          {loading ? '加载方案…' : `方案「${name || '—'}」 总液 ${fluid} m³ · 总砂 ${prop} t`}
        </span>
      </div>

      {/* 单价输入 */}
      <div style={{ padding: '10px 20px', display: 'flex', gap: 16, flexWrap: 'wrap', borderBottom: `1px solid ${ETH.headerBorder}`, background: ETH.panelHeaderBg }}>
        <Lab t="液单价 元/m³"><input type="number" value={p.fluidPrice} style={ecoInputStyle} onChange={(e) => set('fluidPrice', +e.target.value)} /></Lab>
        <Lab t="砂单价 元/t"><input type="number" value={p.proppantPrice} style={ecoInputStyle} onChange={(e) => set('proppantPrice', +e.target.value)} /></Lab>
        <Lab t="化学剂 万元"><input type="number" value={p.chemicalCost} style={ecoInputStyle} onChange={(e) => set('chemicalCost', +e.target.value)} /></Lab>
        <Lab t="设备 万元"><input type="number" value={p.equipmentCost} style={ecoInputStyle} onChange={(e) => set('equipmentCost', +e.target.value)} /></Lab>
        <Lab t="人工 万元"><input type="number" value={p.laborCost} style={ecoInputStyle} onChange={(e) => set('laborCost', +e.target.value)} /></Lab>
        <Lab t="其他 万元"><input type="number" value={p.otherCost} style={ecoInputStyle} onChange={(e) => set('otherCost', +e.target.value)} /></Lab>
      </div>

      <div style={{ flex: 1, overflow: 'auto', padding: '24px 32px', maxWidth: 720 }}>
        {/* 总成本大数字 */}
        <div style={{ marginBottom: 24 }}>
          <div style={{ fontSize: 12, color: ETH.textMuted }}>压裂总投资 (CAPEX)</div>
          <div style={{ fontSize: 34, fontWeight: 800, color: ETH.accent, fontFamily: ETH.fontMono }}>
            {total.toFixed(1)}<span style={{ fontSize: 16, fontWeight: 400, color: ETH.textSec, marginLeft: 6 }}>万元</span>
          </div>
        </div>
        {/* 横条 */}
        {items.map((it, i) => (
          <div key={it.name} style={{ marginBottom: 12 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, marginBottom: 3 }}>
              <span style={{ color: ETH.text, fontWeight: 600 }}>{it.name}</span>
              <span style={{ fontFamily: ETH.fontMono, color: ETH.textSec }}>
                {it.val.toFixed(1)} 万元 · {((it.val / total) * 100).toFixed(0)}%
              </span>
            </div>
            <div style={{ height: 14, background: '#EEF1F5', borderRadius: 7, overflow: 'hidden' }}>
              <div style={{ width: `${(it.val / maxVal) * 100}%`, height: '100%', background: BAR_COLOR[i % BAR_COLOR.length], borderRadius: 7 }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function Lab({ t, children }: { t: string; children: React.ReactNode }) {
  return (
    <label style={{ fontSize: 11, color: ETH.textSec, display: 'flex', flexDirection: 'column', gap: 3 }}>
      {t}{children}
    </label>
  );
}
